module.exports = __webpack_public_path__ + "media/images/gallery/constellations/orion/ori_vis-78d825881387843b73bff25e8c2a3778.png";